"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLineChart = exports.yAxisBuffer = void 0;
var lodash_1 = require("lodash");
var chartHooks_1 = require("../../../hooks/charts/chartHooks");
var miscHooks_1 = require("../../../hooks/miscHooks");
var objectUtilities_1 = require("../../../util/objectUtilities");
var LineChart_style_1 = __importDefault(require("./LineChart.style"));
exports.yAxisBuffer = 1.05;
function useLineChart(_a) {
    var _b, _c;
    var mode = _a.mode, numberOfYTicks = _a.numberOfYTicks, data = _a.data, loading = _a.loading;
    var xScale = {
        type: 'time',
        format: mode === 'daily' ? '%Y-%m-%d' : '%Y-%m',
        precision: mode === 'daily' ? 'day' : 'month',
        useUTC: false,
    };
    var yMaxRaw = (_b = (0, lodash_1.maxBy)((0, objectUtilities_1.filterMap)(data, function (_a) {
        var data = _a.data;
        return (0, lodash_1.maxBy)(data, function (datum) { return datum.y; });
    }), function (datum) { return datum.y; })) === null || _b === void 0 ? void 0 : _b.y;
    return __assign(__assign({}, (0, chartHooks_1.useDateAxisTicks)((_c = data[0]) === null || _c === void 0 ? void 0 : _c.data)), { classes: (0, LineChart_style_1.default)(), isEmpty: !loading && !(0, lodash_1.flatMap)(data, 'data').length, randomNumbers: (0, miscHooks_1.useRandomNumbers)({ range: { end: 100, start: 20 } }), tickValuesY: numberOfYTicks || 3, xFormat: mode === 'daily' ? '%b %d' : '%b', xScale: xScale, yMax: yMaxRaw && typeof yMaxRaw === 'number' ? yMaxRaw * exports.yAxisBuffer : undefined });
}
exports.useLineChart = useLineChart;
